module.exports = __webpack_public_path__ + "img/jianhangbanner.93babff8.png";